import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
//UI
import HomeLayout from '../../../layouts/HomeLayout';
import MainLoader from '../../../components/Loaders/MainLoader';
import Error from '../../../components/errors/Error';
import HeaderForm from '../../../components/headers/catalogs/HeaderForm';
import CardButtonProcess from '../../../components/cards/CardButtonProcess';
import { FaFileCirclePlus } from 'react-icons/fa6';

//SLICE
import CardButtonEdit from '../../../components/cards/CardButtonEdit';
import BtnTable from '../../../components/buttons/BtnTable';
import { deleteFormThunk, getFormsThunk } from '../../../store/slices/catalogs/forms.slice';

const FormsList = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { items, message, error } = useSelector(state => state.forms);
    const isLoading = useSelector(state => state.isLoadingSlice);

    useEffect(() => {
        dispatch(getFormsThunk());
    }, []);

    if (message === "Registro eliminado correctamente") {
        dispatch(getFormsThunk());
    }

    const handledelete = (id) => {
        dispatch(deleteFormThunk(id));
    };

    return (
        <HomeLayout>
            {isLoading ? (
                <MainLoader />
            ) : (
                <div className='mx-5 my-5 w-full'>
                    {error ? <Error state={error} /> : " "}
                    <HeaderForm title={t("Formularios")} />
                    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6 xl:grid-cols-3 2xl:gap-7.5 mt-5">
                        <CardButtonProcess title={'Crear nuevo formulario'} background={'bg-slate-100'} to={`/panel/forms/form_new`} >
                            <FaFileCirclePlus size={60} className='text-blue-600/80' />
                        </CardButtonProcess>
                        {
                            items.map(item => (
                                <CardButtonEdit
                                    title={item.titulo}
                                    background={'bg-slate-100'}
                                >
                                    <BtnTable action="edit" to={`/panel/forms/${item.id}`} />
                                    <BtnTable title={"¿Quieres eliminar este contrato?"} action="delete" onclick={() => handledelete(item.id)} />
                                </CardButtonEdit>
                            ))
                        }
                    </div>
                </div>
            )}
        </HomeLayout>
    );
};

export default FormsList;